import { render, staticRenderFns } from "./AssetsMap.vue?vue&type=template&id=b8ea74c8&scoped=true&"
import script from "./AssetsMap.vue?vue&type=script&lang=js&"
export * from "./AssetsMap.vue?vue&type=script&lang=js&"
import style0 from "./AssetsMap.vue?vue&type=style&index=0&id=b8ea74c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ea74c8",
  null
  
)

export default component.exports